import { Navigate, useLocation } from "react-router-dom";
import React from "react";
import { getTokenCookie } from "../../utils/storage";

const PrivateRoute = ({ children }) => {
  const authed = getTokenCookie();
  const location = useLocation();

  if (!authed)
    return <Navigate to="/login" state={{ from: location }} replace />;

  return children;
};

export default PrivateRoute;
